export default {
	namespaced: true,
	state: {
		param: {

		},
		data: {},
	},
	getters: {
		param(state) {
			return state.param
		},
		data(state) {
			return state.data
		},
	},
	mutations: {
		param(state, data) {
			state.param = data
		},
		data(state, data) {
			state.data = data
		},
	},
	actions: {
		setParam(context, data) {
			context.commit('param', data)
		},
		setData(context, data) {
			context.commit('data', data)
		},
	},
}
